import React from 'react';
import PropTypes from 'prop-types';
import { getDisplayValueFromList } from 'components/utils';
import chevronGreyIcon from 'assets/images/icons/chevron-grey.svg';
import MultiLevelSelect from 'components/form-components/MultiLevelSelect';
import NumberField from 'components/form-components/NumberField';
import { useTranslation } from 'react-i18next';

const TimeWithUnitField = ({
  timeName,
  unitName,
  timeValue,
  unitValue,
  unitOptions,
  handleChange,
  fullWidth = true,
}) => {
  const { t } = useTranslation();
  const handleTimeChange = (field, value) => {
    handleChange(timeName, Number(value));
  };

  const handleUnitChange = (field, value) => {
    handleChange(unitName, value[0]);
  };

  return (
    <div className='d-flex gap-3'>
      <NumberField
        name={timeName}
        value={parseInt(timeValue) || 1}
        handleChange={handleTimeChange}
        shrink
        classes={'w-25'}
        min={1}
      />

      <div className='flex-grow-1'>
        <MultiLevelSelect
          name={unitName}
          options={{ children: unitOptions }}
          value={[]}
          handleChange={handleUnitChange}
          toggleClasses='px-2 py-2 d-flex gap-2 justify-content-between align-items-center rounded-sm cursor-pointer border-grey-1-h-1'
          toggleComponent={
            <>
              <label className='theme-size-0_9 cursor-pointer overflow-hidden'>
                {t(getDisplayValueFromList(unitOptions, unitValue, 'select_select'))}
              </label>
              <img src={chevronGreyIcon} className='rotate-180' />
            </>
          }
          fullWidth={fullWidth}
        />
      </div>
    </div>
  );
};

TimeWithUnitField.propTypes = {
  timeName: PropTypes.string.isRequired,
  unitName: PropTypes.string.isRequired,
  timeValue: PropTypes.number.isRequired,
  unitValue: PropTypes.string.isRequired,
  unitOptions: PropTypes.array.isRequired,
  handleChange: PropTypes.func.isRequired,
  fullWidth: PropTypes.bool,
};

export default TimeWithUnitField;
